// LIBRERIE/IMPORTAZIONI
import React from 'react';
import { useTranslation } from 'react-i18next';
import '@flaticon/flaticon-uicons/css/all/all.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import he from 'he';

// COMPONENTI
import WidgetContactItem from "./WidgetContactItem";

// CONFIGURAZIONI
import { appConfig } from "../../../config/appConfig";

interface Props {
  agencyDataAddress: string;
  agencyDataCity: string;
  agencyDataComuneCapoluogo: boolean;
  agencyDataProvinciaSigla: string;
  agencyDataEmail: string;
  agencyDataEmailShow: boolean;
  agencyDataPhone1: string;
  agencyDataPhone2?: string;
  agencyDataInternationalPrefix: string;
  agencyDataMobile?: string;
  agencyDataMobile2?: string;
  agencyDataFax?: string;
  agencySocialShow?: boolean;
  agencyDataWhatsapp?: string;
  agencyDataFacebook?: string;
  agencyDataInstagram?: string;
  agencyDataTwitter?: string;
  agencyDataLinkedin?: string;
  agencyDataPinterest?: string;
  agencyDataYoutube?: string;
  agencyDataTikTok?: string;
  agencyDataThreads?: string;
}

export const ContactAddress: React.FC<Props> = ({
  agencyDataAddress,
  agencyDataCity,
  agencyDataComuneCapoluogo,
  agencyDataProvinciaSigla,
  agencyDataEmail,
  agencyDataEmailShow,
  agencyDataPhone1,
  agencyDataPhone2,
  agencyDataInternationalPrefix,
  agencyDataMobile,
  agencyDataMobile2,
  agencySocialShow,
  agencyDataWhatsapp,
  agencyDataFacebook,
  agencyDataInstagram,
  agencyDataTwitter,
  agencyDataLinkedin,
  agencyDataPinterest,
  agencyDataYoutube,
  agencyDataTikTok,
  agencyDataThreads
}) => {
  const { t } = useTranslation();

  const decodedAddress = he.decode(agencyDataAddress);
  const dbAddress = decodedAddress;

  return (

    <div className="contact-address widget mb-4">

      <div className="widget-title">
        <h3>{t('widgets.contacts.title') || ""}</h3>
      </div>

      <div className='p-3'>
        {/* Address */}
        {agencyDataAddress ? (
          <div className="d-flex mb-3">
            <div className="contact-address-icon">
              <i className="flaticon-map text-primary font-xlll"></i>
            </div>
            <div>
              <h6>{t('common.address')}</h6>
              <p className='mb-0'>
                {appConfig.agency.customAddress !== "" ? (
                  appConfig.agency.customAddress
                ) : (
                  dbAddress + ', ' + agencyDataCity + (agencyDataComuneCapoluogo ? '' : ' ( ' + agencyDataProvinciaSigla + ' )')
                )}
              </p>
            </div>
          </div>
        ) : null}

        {/* Email */}
        {agencyDataEmailShow && agencyDataEmail ? (
          <div className="d-flex mb-3">
            <div className="contact-address-icon">
              <i className="flaticon-email text-primary font-xlll"></i>
            </div>
            <div>
              <h6>{t('widgets.contacts.emailLabel')}</h6>
              <p><a href={`mailto:${agencyDataEmail}`} title={t('widgets.contacts.emailTitle') || 'Invia una email'}>{agencyDataEmail}</a></p>
            </div>
          </div>
        ) : null}

        {/* Telefono */}
        <WidgetContactItem
          iconClass="flaticon-telephone"
          label={t('widgets.contacts.phoneLabel')}
          title={t('widgets.contacts.phoneTitle') || "Telefono"}
          tel1={
            appConfig.agency.customPhone
              ? `${agencyDataInternationalPrefix} ${appConfig.agency.customPhone}`
              : agencyDataPhone1
                ? `${agencyDataInternationalPrefix} ${agencyDataPhone1}`
                : null
          }
          tel2={
            appConfig.agency.customPhone2
              ? `${agencyDataInternationalPrefix} ${appConfig.agency.customPhone2}`
              : agencyDataPhone2
                ? `${agencyDataInternationalPrefix} ${agencyDataPhone2}`
                : null
          }
          visible={
            !!(appConfig.agency.customPhone || agencyDataPhone1 || appConfig.agency.customPhone2 || agencyDataPhone2)
            && appConfig.ui.agencyWidget.showPhone
          }
        />

        {/* Mobile */}
        <WidgetContactItem
          iconClass="flaticon-call"
          label={t('widgets.contacts.mobileLabel')}
          title={t('widgets.contacts.mobileTitle') || "Cellulare"}
          tel1={
            appConfig.agency.customMobile
              ? `${agencyDataInternationalPrefix} ${appConfig.agency.customMobile}`
              : agencyDataMobile
                ? `${agencyDataInternationalPrefix} ${agencyDataMobile}`
                : null
          }
          tel2={
            appConfig.agency.customMobile2
              ? `${agencyDataInternationalPrefix} ${appConfig.agency.customMobile2}`
              : agencyDataMobile2
                ? `${agencyDataInternationalPrefix} ${agencyDataMobile2}`
                : null
          }
          visible={
            !!(appConfig.agency.customMobile || agencyDataMobile || appConfig.agency.customMobile2 || agencyDataMobile2)
            && appConfig.ui.agencyWidget.showMobile
          }
        />

        {/* Social Media */}
        {agencySocialShow && (agencyDataWhatsapp || agencyDataFacebook || agencyDataInstagram || agencyDataTwitter || agencyDataLinkedin || agencyDataPinterest) && (
          <div className="social-icon-02">
            <div className="d-flex align-items-center">
              <h6 className="mr-3">Social:</h6>
              <ul className="list-unstyled mb-0 list-inline">
                {agencyDataWhatsapp && (
                  <li className='mr-2'>
                    <a
                      title="Whatsapp"
                      target="_blank"
                      className="whatsapp"
                      href={`https://api.whatsapp.com/send?phone=${agencyDataWhatsapp}`}
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-whatsapp"></i>
                    </a>
                  </li>
                )}
                {agencyDataFacebook && (
                  <li className='mr-2'>
                    <a className="facebook" href={agencyDataFacebook} target="_blank" title="Facebook" rel="noopener noreferrer">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li>
                )}
                {agencyDataInstagram && (
                  <li className='mr-2'>
                    <a className="instagram" href={agencyDataInstagram} target="_blank" title="Instagram" rel="noopener noreferrer">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                )}
                {agencyDataTwitter && (
                  <li className='mr-2'>
                    <a href={agencyDataTwitter} target="_blank" title="Twitter" rel="noopener noreferrer">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </li>
                )}
                {agencyDataLinkedin && (
                  <li className='mr-2'>
                    <a href={agencyDataLinkedin} target="_blank" title="LinkedIn" rel="noopener noreferrer">
                      <i className="fab fa-linkedin"></i>
                    </a>
                  </li>
                )}
                {agencyDataPinterest && (
                  <li>
                    <a href={agencyDataPinterest} target="_blank" title="Pinterest" rel="noopener noreferrer">
                      <i className="fab fa-pinterest"></i>
                    </a>
                  </li>
                )}
                {agencyDataYoutube && (
                  <li>
                    <a href={agencyDataYoutube} target="_blank" title="Youtube" rel="noopener noreferrer">
                      <i className="fab fa-youtube"></i>
                    </a>
                  </li>
                )}
                {agencyDataTikTok && (
                  <li>
                    <a href={agencyDataTikTok} target="_blank" title="TikTok" rel="noopener noreferrer">
                      <i className="fab fa-tiktok"></i>
                    </a>
                  </li>
                )}
                {agencyDataThreads && (
                  <li>
                    <a href={agencyDataThreads} target="_blank" title="Threads" rel="noopener noreferrer">
                      <i className="fab fa-threads"></i>
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        )}
    </div>
    </div>
  );
};

export default ContactAddress;